import { createSelector } from '@reduxjs/toolkit';
import selectPreferences from './selectPreferences';

/**
 * A higher-order selector for retrieving the specified preference.
 * @param {import('@socialive/common').PREFERENCE} preference
 * @returns {Selector}
 */
export default (preference) => createSelector(selectPreferences, (preferences) => preferences[preference]);
